import Gehanee from "../assets/avatars/1 gehanee.jpg";
import Amjad from "../assets/avatars/2 amjad.png";
import Tharusha from "../assets/avatars/3 tharusha.png";
import Kirushanka from "../assets/avatars/4 kirushanka.jpg";
import Chamod from "../assets/avatars/5 chamod.png";
import Yasas from "../assets/avatars/6 yasas.png";
import Aadil from "../assets/avatars/7 aadil.png";
import Senali from "../assets/avatars/8 senali.jpg";


const AllContributors = [
  {
    id: 110,
    name: "Gehanee",
    avatar: Gehanee,
    degree: "Bachelor of Business Management (Honours)",
    status: "Graduate",
    moreDetails:
      " Gold medalist of the batch. Fresh graduate. ",
  },
  {
    id: 101,
    name: "Amjad",
    avatar: Amjad,
    degree: "Ll.B (Hons) in Law",
    status: "Graduate",
    moreDetails:
      " Attorney at Law. Graduated in 2019.",
  },
  {
    id: 102,
    name: "Tharusha",
    avatar: Tharusha,
    degree: "BEng (Hons) Biomedical Engineering",
    status: "Undergraduate",
    moreDetails:
      " Working as a Biomedical trainee.",
  },
  {
    id: 103,
    name: "Kirushanka",
    avatar: Kirushanka,
    degree: "Bachelor of Architecture",
    status: "Undergraduate",
    moreDetails:
      " President of the Rotaract club.",
  },
  {
    id: 104,
    name: "Chamod",
    avatar: Chamod,
    degree: "Bachelor of Science in Logistics Management ",
    status: "Graduate",
    moreDetails:
      " Working at a large sclae logistics company. Graduated in 2017",
  },
  {
    id: 105,
    name: "Yasas",
    avatar: Yasas,
    degree: "Bachelor of Software Engineering (Honours)",
    status: "Undergraduate",
    moreDetails:
      " Secretary of the FOSS club at the university",
  },
  {
    id: 106,
    name: "Aadil",
    avatar: Aadil,
    degree: "BA (Hons) Digital and Social Media Marketing",
    status: "Graduate",
    moreDetails:
      " Working as a marketing manager.",
  },
  {
    id: 107,
    name: "Senali",
    avatar: Senali,
    degree: "Bachelor of Education Honours in English ",
    status: "Graduate",
    moreDetails:
      " Working as an English teacher at an international school.",
  },
  // {
  //   id: 108,
  //   name: "Thivvyan",
  //   avatar: Thivvyan,
  //   degree: "BSc Computer Science",
  //   status: "Undergraduate",
  //   moreDetails:
  //     " Computer Science Gold Medalist (2019) currently working as a BA at PickMe Sri Lanka.",
  // },
  // {
  //   id: 109,
  //   name: "Zehana",
  //   avatar: Zehana,
  //   degree: "BSc Computer Science",
  //   status: "Undergraduate",
  //   moreDetails:
  //     " Computer Science Gold Medalist (2019) currently working as a BA at PickMe Sri Lanka.",
  // },
];
export default AllContributors;
